export const LOAD_ROOMS = 'LOAD_ROOMS'
export const ADD_ROOM = 'ADD_ROOM'
